<template>
  <div id="china_map_box">
      <div class="china_map" ref="map"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import '../../utils/map_china' 
export default {
  props: ['mapData'],
  data() {
    return {
       myChart: null,
      dataList: []
    };
  },
  watch: {
    mapData: {
      handler (value) {
        // console.log(value)
          this.dataList = value;
          this.initEchartMap();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    //初始化中国地图
    initEchartMap() {
      this.$nextTick(() => {
      let  option = {
        title: {show: false},
        tooltip: {
            trigger: 'item',
            formatter: function (params) {
                if (typeof (params.value)[2] == "undefined") {
                    return params.name + ' : ' + params.value+ ' (次) ' ;
                } else {
                    return params.name + ' : ' + params.value[2]+ ' (次) ';
                }
            },
            textStyle: {
                color: '#333',
                fontSize: 16
            }
        },
        legend: {
            show: false
        },
        geo: {
            map: 'china',
            scaleLimit: {
            min: 1.2,
            max: 12
          },
            label: {
                normal: {show: false},
                emphasis: {show: false}
            },
            roam: false,
            itemStyle: {
                normal: {
                    areaColor: 'RGBA(91, 155, 213, 1)',
                    borderColor: '#09F'
                },
                emphasis: {
                    areaColor: 'rgba(0,153,255,0.6)',
                    borderColor: '#09F'
                }
            }
        },
        series: [{
            name: '终端使用分布',
            type: 'scatter',
            coordinateSystem: 'geo',
            zlevel: 1,
            rippleEffect: {
                brushType: 'stroke'
            },
            symbolSize: function (val) {
                return 10;
            },
            label: {
                normal: {show: false},
                emphasis: {show: false}
            },
            itemStyle: {
                normal: {color: 'rgba(255,255,0,0.8)'},
                emphasis: {color: 'rgba(246,33,87,1)'}
            },
            data: this.dataList
        },
            // {
            //     name: 'TOP2',
            //     type: 'effectScatter',
            //     coordinateSystem: 'geo',
            //     zlevel: 2,
            //     hoverAnimation: true,
            //     showEffectOn: 'render',
            //     rippleEffect: {
            //         brushType: 'stroke'
            //     },
            //     label: {
            //         normal: {
            //             show: true,
            //             fontFamily: '微软雅黑',
            //             fontSize: 24,
            //             color: '#FFF',
            //             formatter: '{b}',
            //             position: 'right',
            //             shadowBlur: 5,
            //             shadowColor: '#000'
            //         },
            //         emphasis: {
            //             show: true
            //         }
            //     },
            //     symbolSize: function (val) {
            //         return val[2] / 100 > 50 ? 50 : val[2] / 100;
            //     },
            //     itemStyle: {
            //         normal: {
            //             color: 'rgba(255,255,255,1)'
            //         }
            //     },
            //     data: this.dataList.sort(function (a, b) {
            //         return b.value[2] - a.value[2];
            //     }).slice(0, 2)
            // },
            // {
            //     name: '点',
            //     type: 'scatter',
            //     coordinateSystem: 'geo',
            //     symbol: 'pin',
            //     symbolSize: function (val) {
            //         return val[2] / 100 > 100 ? 100 : val[2] / 100;
            //     },
            //     label: {
            //         normal: {
            //             show: true,
            //             fontFamily: 'Arial, Helvetica, sans-serif',
            //             formatter: '{@[2]}',
            //             textStyle: {
            //                 color: '#FFF',
            //                 fontSize: 18,
            //             }
            //         }
            //     },
            //     itemStyle: {
            //         normal: {
            //             color: 'rgba(246,33,87,1)', //标志颜色
            //         }
            //     },
            //     zlevel: 3,
            //     data: this.dataList.sort(function (a, b) {
            //         return b.value[2] - a.value[2];
            //     }).slice(0, 5)
            // }
            ]
    };
      // let option =  {
      //   tooltip: {
      //     triggerOn: "mousemove",   //mousemove、click
      //     padding:8,
      //     borderWidth:1,
      //     borderColor:'#409eff',
      //     backgroundColor:'rgba(255,255,255,0.7)',
      //     textStyle:{
      //       color:'#000000',
      //       fontSize:13
      //     },
      //     // formatter: function(e, t, n) {
      //     //   let data = e.data;
      //     //   //模拟数据
      //     //   // data.specialImportant = Math.random()*1000 | 0;
      //     //   // data.import = Math.random()*1000 | 0;
      //     //   // data.compare = Math.random()*1000 | 0;
      //     //   // data.common = Math.random()*1000 | 0;
      //     //   // data.specail = Math.random()*1000 | 0;

      //     //   let context = `
      //     //      <div>
      //     //          <p><b style="font-size:15px;">${data.name}</b>(2020年第一季度)</p>
      //     //          <p class="tooltip_style"><span class="tooltip_left">事件总数</span><span class="tooltip_right">${data.value}</span></p>
      //     //      </div>
      //     //   `
      //     //   return context;
      //     // }
      //   },
      //   visualMap: {
      //     show:true,
      //     left: 0,
      //     top: 0,
      //     showLabel:true,
      //     pieces: [{
      //         gte: 100,
      //         label: ">= 1000",
      //         color: "#1f307b"
      //       },{
      //         gte: 500,
      //         lt: 999,
      //         label: "500 - 999",
      //         color: "#3c57ce"
      //       },{
      //         gte: 100,
      //         lt:499,
      //         label: "100 - 499",
      //         color: "#6f83db"
      //       },{
      //         gte: 10,
      //         lt: 99,
      //         label: "10 - 99",
      //         color: "#9face7"
      //       },{
      //         lt:10,
      //         label:'<10',
      //         color: "#bcc5ee"
      //       }
      //     ]
      //   },
      //   geo: {
      //     map: "china",
      //     scaleLimit: {
      //       min: 1,
      //       max: 12
      //     },
      //     zoom: 1,
      //     top: 10,
      //     bottom: 0,
      //     label: {
      //       show: false
      //       // normal: {show: false},
      //       // emphasis: {show: false}
      //       // normal: {
      //       //   show:true,
      //       //   fontSize: "14",
      //       //   color: "rgba(0,0,0,0.7)"
      //       // }
      //     },
      //     itemStyle: {
      //       borderColor: "rgba(0, 0, 0, 0.2)",
            
      //       emphasis: {
      //         areaColor: "#f2d5ad",
      //         shadowOffsetX: 0,
      //         shadowOffsetY: 0,
      //         borderWidth: 0
      //       }
      //     }
      //   },
      //   series: [
      //     {
      //       name: "终端使用情况",
      //       type: "map",
      //       geoIndex: 0,
      //       data:this.dataList
      //     }
      //   ]
      // };
      option && this.myChart.setOption(option);
      })
    },
    handleWindowResize() {
        if (!this.myChart) return;
        this.myChart.resize();
    },
  },
  created() {},
  mounted() {
    this.myChart = echarts.init(this.$refs.map);
    this.initEchartMap();
    window.addEventListener("resize", this.handleWindowResize);
  },
  beforeDestroy() {
      window.removeEventListener("resize", this.handleWindowResize);
  },
};
</script>

<style scoped>
  #china_map_box {
      height: 100%;
      /* position: relative; */
  }
  #china_map_box .china_map{
    width:100%;
      height: 100%;
  }
   /*  #china_map_box .china_map_logo{
      position: absolute;
      top: 0;
      left: 0;
      width:45px;
    }
    #china_map .tooltip_style{
    line-height:1.7;
    overflow: hidden;
  }
  #china_map .tooltip_left{
      float: left;
  }
  #china_map .tooltip_right{
      float: right;
  } */
</style>